import { useMemo } from "react";
import { useDataAccumulatorForSingleOrder } from "../../../context/dataAccumulatorForSingleOrder";
import { SubmissionStatusEnum } from "../../../data-model/submissionDocs";

const SUBMISSION_PRESENT_STATUSES: ReadonlySet<SubmissionStatusEnum> = new Set([
  "in_progress",
  "completed",
  "submission_completed",
  "already_filed",
  "payer_not_supported",
  "saved_draft",
  "error",
  "fax_submitted",
  "fax_delivered",
  "fax_error",
  "fax_failed",
  "queued",
]);

/**
 * Returns `true` when the order's Postgres `submission_status` indicates a
 * submission has been attempted or completed (portal or fax).
 *
 * Reads the migrated Postgres status from the single-order accumulator rather
 * than the legacy Firestore order slice, so the "View Submission" / "Start
 * Filing" button stays in sync with the submission status screen — and with a
 * resubmit that clears `submission_status` back to empty.
 *
 * @returns Whether a submission record exists for the order
 */
export const useSubmissionIsPresent = (): boolean => {
  const { generalOrderDetails, workflowConfig } =
    useDataAccumulatorForSingleOrder();

  return useMemo(() => {
    if (workflowConfig?.submission_type === "rpa_nch") {
      return false;
    }
    const submissionStatus = generalOrderDetails?.order?.status
      ?.submission_status as SubmissionStatusEnum | undefined;
    return Boolean(
      submissionStatus && SUBMISSION_PRESENT_STATUSES.has(submissionStatus),
    );
  }, [generalOrderDetails, workflowConfig]);
};
